import { isNotDefined } from '@sgme/fp';

import { workspaceApi } from '@/api/workspace/index.ts';
import { selectSharedTabToSave } from '@/store/sharedWorkspace/selectors.ts';
import type { AppDispatch, AppState } from '@/store/store.ts';

export async function saveCurrentSharedTab({
  getState,
  dispatch,
  cacheKey,
}: {
  getState: () => AppState;
  dispatch: AppDispatch;
  cacheKey?: string;
}) {
  const sharedTab = selectSharedTabToSave(getState());

  if (isNotDefined(sharedTab)) {
    console.warn('try to save a shared tab, but no shared tab to save');
    return;
  }

  return dispatch(workspaceApi.endpoints.shareTab.initiate(sharedTab, { fixedCacheKey: cacheKey }));
}
